import { apiGet } from "./client";
import type { PublicConfig } from "@/types";

/**
 * Endpoint `GET /api/v1/config` (S7-3, R-13 cond. 5).
 *
 * Source de vérité **serveur** pour la `consent_version` RGPD :
 * le frontend lit cette valeur au montage et la transmet au backend
 * dans `POST /sessions/consent`. Si un déploiement front est désynchronisé
 * d'un déploiement backend, le `POST /sessions/consent` répond 409
 * `CONSENT_VERSION_MISMATCH` plutôt que d'accepter silencieusement une
 * version "fantôme".
 *
 * Pas de cookie requis (endpoint public). Cacheable côté client : la
 * valeur change uniquement à chaque bump de la politique de confidentialité.
 */
const BASE = "/api/v1/config";

export function getPublicConfig(): Promise<PublicConfig> {
  return apiGet<PublicConfig>(BASE);
}
